import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Secretary from '../../images/adminAssist.jpg';
// import blogs from '../../api/blogs';

const AdminAssistant = (props) => {
    const { slug } = useParams();
    // const BlogDetails = blogs.find(item => item.slug === slug);

    const jobDetails = {
        title: "Secretary (Administrative Assistant)",
        location: "GRA, Ikeja, Lagos State",
        deadline: "15th March, 2026",
        salary: "₦150,000 Monthly",
        employmentType: "Full-Time (Entry Level)",
        experienceLevel: "0 – 1 Year (Post-NYSC)",
        email: "careers@ffsdgroup.com",
        organization: "Financial Forensic studies and diagnostics (FFSD Group)"
    };

    return (
        <section className="blog-single-section section-padding" aria-label="Job posting details">
            <div className="container mx-auto px-4">
                <div className="flex justify-center">
                    <div className={`w-full lg:w-9/12 ${props.blRight || ''}`}>
                        <article className="blog-content">
                            <div className="tag-share">
                                <div className="post format-standard-image">
                                    <figure className="entry-media mb-6">
                                        <img 
                                            src={Secretary} 
                                            alt={`${jobDetails.organization} office`}
                                            className="w-full h-auto rounded-lg"
                                        />
                                    </figure>
                                    
                                    <ul className="entry-meta flex flex-wrap gap-4 text-sm text-gray-600 mb-4">
                                        <li>
                                            <Link to="/about" className="hover:text-blue-600">
                                                {jobDetails.organization}
                                            </Link>
                                        </li>
                                        <li>
                                            <time dateTime="2026-03-14">
                                                Posted: 3rd March, 2026
                                            </time>
                                        </li>
                                        <li>
                                            <span className="font-semibold text-red-600">
                                                Deadline: {jobDetails.deadline}
                                            </span>
                                        </li>
                                    </ul>

                                    <h1 className="text-2xl md:text-3xl font-bold mb-4">
                                        Job Title: {jobDetails.title}
                                    </h1>
                                    
                                    <div className="bg-gray-50 p-4 rounded-lg mb-6">
                                        <p className="mb-2"><strong>Location:</strong> {jobDetails.location}</p>
                                        <p className="mb-2"><strong>Employment Type:</strong> {jobDetails.employmentType}</p>
                                        <p className="mb-2"><strong>Salary:</strong> {jobDetails.salary}</p>
                                        <p><strong>Experience Level:</strong> {jobDetails.experienceLevel}</p>
                                    </div>

                                    <h3 className="text-xl font-semibold mt-6 mb-3 text-gray-800">About Us</h3>
                                    <p className="mb-4 text-gray-700">
                                        Financial Forensic studies and diagnostics (FFSD Group) is a multi-brand organization 
                                        seeking a highly proactive and disciplined Secretary (Administrative Assistant) to provide 
                                        high-level operational support within our Administrative team. We require a candidate who 
                                        will act as a central hub for office operations, ensuring that documentation, communication, 
                                        and daily tasks align with FFSD Group's core values of Integrity and Transparency.
                                    </p>

                                    <h3 className="text-xl font-semibold mt-6 mb-3 text-gray-800">Role Objective</h3>
                                    <p className="mb-4 text-gray-700">
                                        To provide comprehensive administrative support, ensuring smooth office operations and 
                                        maintaining the highest standards of professionalism and efficiency.
                                    </p>

                                    <h3 className="text-xl font-semibold mt-6 mb-3 text-gray-800">Key Responsibilities</h3>
                                    <ul className="mb-4 space-y-2" style={{ listStyleType: 'disc', paddingLeft: '1.5rem' }}>
                                        <li className="text-gray-700 leading-relaxed">Log, track, and facilitate responses to internal and external operational requests within established service timelines.</li>
                                        <li className="text-gray-700 leading-relaxed">Act as a liaison between departments to ensure the timely execution of cross-functional tasks.</li>
                                        <li className="text-gray-700 leading-relaxed">Manage daily office errands and provide general support to ensure a hazard-free and organized work environment.</li>
                                        <li className="text-gray-700 leading-relaxed">Document meeting minutes and transcribe recorded meetings accurately, ensuring timely submission.</li>
                                        <li className="text-gray-700 leading-relaxed">Maintain a 'Clear Desk' environment by ensuring all non-personnel business documents are filed securely.</li>
                                        <li className="text-gray-700 leading-relaxed">Coordinate complex meeting calendars, send reminders, and manage logistics for engagements.</li>
                                        <li className="text-gray-700 leading-relaxed">Attend meetings to record accurate minutes and track actionable items for follow-up.</li>
                                        <li className="text-gray-700 leading-relaxed">Identify potential operational bottlenecks and recommend practical, ethical solutions.</li>
                                    </ul>

                                    <h3 className="text-xl font-semibold mt-6 mb-3 text-gray-800">Requirements</h3>
                                    <ul className="mb-4 space-y-2" style={{ listStyleType: 'disc', paddingLeft: '1.5rem' }}>
                                        <li className="text-gray-700 leading-relaxed">Bachelor's Degree (B.Sc.) in Social Sciences, Business Administration, or related discipline.</li>
                                        <li className="text-gray-700 leading-relaxed">0 – 1 year post-NYSC with proven administrative internship or support role experience.</li>
                                        <li className="text-gray-700 leading-relaxed">Expert proficiency in Microsoft Excel, Word, PowerPoint, and Google Workspace (G-Suite).</li>
                                        <li className="text-gray-700 leading-relaxed">High Emotional Intelligence (EQ) and professional confidence.</li>
                                        <li className="text-gray-700 leading-relaxed">Ability to thrive in a fast-paced, structured environment.</li>
                                    </ul>

                                    <h3 className="text-xl font-semibold mt-6 mb-3 text-gray-800">How to Apply</h3>
                                    <div className="bg-blue-50 p-4 rounded-lg mb-4">
                                        <p className="mb-2">
                                            Interested candidates should submit their CV to{' '}
                                            <a 
                                                href={`mailto:${jobDetails.email}?subject=Application – ${encodeURIComponent(jobDetails.title)}`}
                                                className="text-blue-600 hover:underline font-semibold"
                                            >
                                                {jobDetails.email}
                                            </a>
                                        </p>
                                        <p className="text-sm text-gray-600">
                                            Subject line: <span className="font-mono bg-white px-2 py-1 rounded">
                                                Application – {jobDetails.title}
                                            </span>
                                        </p>
                                    </div>

                                    <h3 className="text-xl font-semibold mt-6 mb-3 text-gray-800">Application Deadline</h3>
                                    <p className="mb-4 text-gray-700 font-semibold">
                                        {jobDetails.deadline}
                                    </p>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdminAssistant;